import { defineMessages } from 'react-intl';

export default defineMessages({
  skiplinks: {
    id: 'Skip links',
    defaultMessage: 'Skip links',
  },
  skiplinkMainContent: {
    id: 'skiplink-main-content',
    defaultMessage: 'Skip to main content',
  },
  skiplinkNavigation: {
    id: 'skiplink-navigation',
    defaultMessage: 'Skip to navigation',
  },
  skiplinkSearchbox: {
    id: 'skiplink-search',
    defaultMessage: 'Skip to searchbox',
  },
  skiplinkFooter: {
    id: 'skiplink-footer',
    defaultMessage: 'Skip to footer',
  },
});
